const config = {
  apiUrl:
    window.location.hostname === 'localhost'
      ? 'http://localhost:8080'
      : 'https://portalgeobim.com.br/portalpsa',
};

export default config;
